/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getDeposits } from "./../../helpers/deposits";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  Skeleton,
  Button,
} from "@mui/material";
import moment from "moment";
import { ToggleDepositModal } from "./../../store/actions/app.js";

const Deposits = () => {
  // state
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  // redux
  const { token } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // lifecycles
  useEffect(() => {
    handleGetDeposits();
  }, []);

  // methods
  const handleGetDeposits = async () => {
    try {
      const [, response] = await getDeposits(token);
      setList(response.data);
      setLoading(false);
    } catch(err) {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex align-items-center mb-3 justify-content-between">
          <Typography variant="h6" fontWeight={700}>
            Deposits
          </Typography>
          <Button 
            size="small" 
            variant="contained" 
            className="ms-3"
            onClick={() => {
              dispatch(ToggleDepositModal(true, 0));
            }}
            >Deposit
          </Button>
        </div>
        <TableContainer component={Paper}>
          <Table size="small" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell align="left">Amount</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left">Bank Account</TableCell>
                <TableCell align="right">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan="4">
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                  </TableCell>
                </TableRow>
              )}
              {!loading && list.length === 0 && (
                <TableRow>
                  <TableCell className="text-center" sx={{ border: 0 }} colSpan={4}>
                    <Typography my={2} variant="body2">You don't have any deposits yet.</Typography>
                  </TableCell>
                </TableRow>
              )}
              {!loading && list.length > 0 && (
                <>
                  {list.map((item, i) => (
                    <TableRow
                      hover={true}
                      key={i}
                      sx={{ 
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                      >
                        {parseFloat(item.amount).toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </TableCell>
                      <TableCell align="left">
                        {item.status}
                      </TableCell>
                      <TableCell align="left">
                        {item?.bank_account?.last4} {item?.bank_account.bank}
                      </TableCell>
                      <TableCell align="right">
                        {moment(item.createdAt).format(
                          "MMM D YYYY, h:mm a"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  )
};
export default Deposits;
